import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { SharedService } from './shared/shared.service';
import { Component, ViewContainerRef, ViewEncapsulation, OnDestroy, HostListener, Inject, OnInit } from '@angular/core';
import { ToastsManager } from 'ng2-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {LOCAL_STORAGE, WebStorageService} from 'angular-webstorage-service';
import { environment } from '../environments/environment';
import { Http, Headers } from '@angular/http';

export enum KEY_CODE {
  RIGHT_ARROW = 39,
  LEFT_ARROW = 37,
  F5 = 116
}
@Component({ 
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class AppComponent {

	public constructor(private toastr: ToastsManager, private viewContainerRef: ViewContainerRef) {
		this.toastr.setRootViewContainerRef(viewContainerRef);
	}
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHander(event) {
    return false;
  }
}
/*
export class AppComponent implements OnInit {

  usuario: any;
  public baseUrl: string;
  auth_token;
  public constructor(
    private _http: Http,
    private toastr: ToastsManager,
    private sharedService: SharedService,
    private datePipe: DatePipe,
    private router: Router,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private viewContainerRef: ViewContainerRef)
  {
    this.baseUrl = environment.apiUrl;
    this.toastr.setRootViewContainerRef(viewContainerRef);
    
    this.usuario = this.storage.get('Usuario');
    //console.log("Este es el usuario: ", this.usuario);
    //console.log(this.sharedService.user);
  }

  ngOnInit() {
    // Acá voy a cancelar la petición!
    /*
    window.onbeforeunload = ()=>{
      //call API here
      this.sharedService.secondLogOut(this.usuario.id).subscribe(
        data => {
          console.log("data: ", data);
        }, error => {
          console.log("Ups. Hubo un error! ", error);
        });
    }*/
    /*
    window.addEventListener("onunload", function (evt) {
      this.postcall2();
    }, false);*/
    /*
    window.onbeforeunload = ()=>{
      //call API here
      this.postcall2();
    }
    
    
    this.auth_token = this.sharedService.getCookie("auth_token");
    if (this.storage.get('Usuario') != null) {
      

      this.sharedService.getLastToken(this.usuario.id).subscribe(data => {
        console.log("Esto es lo que retorna el servidor: ", data.data);
        
        //if (data.data > 1000000000000000000000000000) {
        if (data.data > 180) {
          this.router.navigateByUrl("/auth").then(e => {
            if (e) {
              //console.log("Navigation is successful!");
              this.sharedService.user = null;
              this.sharedService.setCookie('auth_token', '', -1, environment.c_domain);
            } else {
              //console.log("Navigation has failed!");
            }
          });
        }
      }, error => {
        //console.log("Ups, hubo un error: ", error)    
      });
    } else {
      //console.log("No hay usuarios logeado");
    }
    
  }
  /*
  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {
    //this.postcall3();
    let data = {
      auth_token: this.auth_token,
      user_id: this.usuario.id
    };
    let headers = {
      type: 'application/json'
    };
    let blob = new Blob([JSON.stringify(data)], headers);
    console.log("Va por acá ");
    var xhr = new XMLHttpRequest();
    xhr.open("POST", this.baseUrl + 'user/secondLogOut', true); // third parameter of `false` means synchronous
    xhr.send(blob); 
  }*/
/* */
  /*
  @HostListener('window:unload', ['$event'])
  async ngOnDestroy() {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    await this.postcall2().then(() => {
      console.log("Terminó el Proceso");
    }, error => {
        console.log("Error en el Proceso!");
    });

  }*/
  /*
  alert() {
    alert("said");
  }*/
    
  /*
  @HostListener('window:beforeunload', ['$event'])
  async beforeUnloadHander(event) {
    
    await this.postcall2();
    //await this.delay(3000);
    return false;
    //return null;
    //event.returnValue = false;
  }*/
  /*
  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }*/
  /*
  async postcall2() {
    //if (this.storage.get('Usuario') != null) {
      //console.log(this.usuario.id);
      let data = {
        auth_token: null,
        user_id: this.usuario.id
      };
      console.log("data: ", data);
      this.alert();
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Accept', 'application/json');
      headers.append('Authorization', 'Bearer ' + data.auth_token);
      console.log("Estos son los headers: ", headers);
      return await this._http.post(this.baseUrl + 'user/secondLogOut', data, { headers: headers })
        .map(res => res.json()).toPromise();
      /*
      console.log("data: ", data);
      this.alert();
      this.sharedService.secondLogOut(data).subscribe(
        data => {
          console.log("data: ", data);
        }, error => {
          console.log("Ups. Hubo un error! ", error);
        });*/
    /*
    await this.sharedService.secondLogOut(this.usuario.id).subscribe(
      data => {
        console.log("data: ", data);
      }, error => {
        console.log("Ups. Hubo un error! ", error);
      });*
    //}
  }*

  postcall3() {
    //if (this.storage.get('Usuario') != null) {
      //console.log(this.usuario.id);
      let data = {
        auth_token: this.auth_token,
        user_id: this.usuario.id
      };
  
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Accept', 'application/json');
      headers.append('Authorization', 'Bearer ' + data.auth_token);
  
      return this._http.post(this.baseUrl + 'user/secondLogOut', data, { headers: headers })
        .map(res => res.json());*/
    /*
    await this.sharedService.secondLogOut(this.usuario.id).subscribe(
      data => {
        console.log("data: ", data);
      }, error => {
        console.log("Ups. Hubo un error! ", error);
      });*
    //}
  }

  
  
  /*
  // Some Form Submitted!
  @HostListener('submit', ['$event'])
  onSubmit(event: Event) {
    console.log('Form submitted!');
  }

  

  PostCall2() {
    console.log("Entro acá ");
  }

  // Para f5!
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    //console.log(event);
    if (event.keyCode === KEY_CODE.F5) {
      console.log("Entramos a f5");
    }
  }

  @HostListener('mouseenter', ['$event'])
  onMouseEnter(event: any) {    
    // Logs the id of the element 
    // where the event is originally invoked.     
    
    console.log("ME", event.clientX);
    console.log("ME",event.clientY);
  }
  /*
  @HostListener('mouseover', ['$event'])
  onMouseOver(event: any) {    
    // Logs the id of the element 
    // where the event is originally invoked.     
    console.log(event.clientX);
    console.log(event.clientY);
  }*

@HostListener('click', ['$event'])
onClick(e) {
   console.log(e);
}

  @HostListener('mouseout', ['$event'])
  onMouseOut(event: any) {    
    if (event.clientX < 0 && event.clientY < 0){
      alert("Window closed");
    }
    else{
      //alert("Window refreshed");
    }
    // Logs the id of the element 
    // where the event is originally invoked.     
    console.log("MO", event.clientX);
    console.log("MO", event.clientY);
  }



  */




  /*
  @HostListener('mouseenter', ['$event'])
  onMouseEnter(event: any) {    
    // Logs the id of the element 
    // where the event is originally invoked.     
    console.log(event);
  }*/

  /*
  myFunction() {
    if (window.closed) {
      this.storage.set('WindowClosed', true);
    }
  }*
}

/*
Function ‘onload’ – it is fired when we refresh browser tab.

Function ‘unload’ – it is fired when we either refresh browser tab or close browser tab.
*/



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/app.component.ts